<template>
  <div class="g-bd">
    <div class="con-list f-clearfix">
      <div class="my-msg">
        <a
          class="go-mooc"
          href="https://www.icourse163.org/home.htm"
          target="_blank"
          >前往中国大学MOOC ></a
        >

        <el-tabs v-model="activeName" @tab-click="handleClick">
          <el-tab-pane label="个人信息" name="first"></el-tab-pane>
          <el-tab-pane label="修改密码" name="second"></el-tab-pane>
        </el-tabs>
        <div class="my-msg-detail">
          <el-form
            ref="addForm"
            :model="addForm"
            label-width="120px"
            :rules="rules"
            v-if="activeName == 'first'"
          >
            <el-form-item label="账号:">
              {{ addForm.userName }}
            </el-form-item>
            <el-form-item label="姓名:" prop="realName">
              <el-input v-model="addForm.realName"></el-input>
            </el-form-item>
            <el-form-item label="性别:" prop="gender">
              <el-radio-group v-model="addForm.gender">
                <el-radio :label="1">男</el-radio>
                <el-radio :label="2">女</el-radio>
              </el-radio-group>
            </el-form-item>
            <el-form-item label="头像:" class="unload-row" prop="avatar">
              <el-upload
                class="avatar-uploader"
                :action="uploadUrl"
                :show-file-list="false"
                :on-success="handleAvatarSuccess"
                :before-upload="beforeAvatarUpload"
                style="text-align: left"
              >
                <div v-if="addForm.avatar" class="image-con">
                  <img :src="imgUrl + addForm.avatar" class="avatar" />
                  <div class="imang_hover">
                    <span>更换图片</span>
                  </div>
                </div>
                <div v-else class="image-icon">
                  <i class="el-icon-plus avatar-uploader-icon"></i>
                  <div class="imang_hover">
                    <span>上传图片</span>
                  </div>
                </div>
                <div class="image-detail">
                  <p>
                    图片最佳尺寸为200x200px<br />文件不可超过1MB<br />支持jpg、jpeg、png、bmp格式图片
                  </p>
                </div>
              </el-upload>
            </el-form-item>
            <el-form-item label="手机号:">
              {{ addForm.mobile }}
            </el-form-item>
            <el-form-item label="邮箱:">
              <el-input v-if="isEmail" v-model="addForm.email"></el-input>
              <span v-else>{{ addForm.email }}</span>
              <span @click="isEmail = !isEmail" class="change-email">{{
                isEmail ? "取消" : "更换邮箱"
              }}</span>
            </el-form-item>

            <el-form-item label="所属院校:">
              {{ addForm.schoolName }}</el-form-item
            >

            <el-form-item align="left" class="dialog-btns">
              <el-button type="primary" @click="saveUser">保存</el-button>
            </el-form-item>
          </el-form>
        </div>
        <div class="my-msg-detail">
          <el-form
            v-if="activeName == 'second'"
            ref="signForm"
            :model="signForm"
            label-width="120px"
            :rules="rulesPass"
          >
            <el-form-item prop="passwordOld" label="原登录密码:">
              <el-input v-model="signForm.passwordOld" show-password></el-input>
            </el-form-item>
            <el-form-item prop="passwordNew" label="新登录密码:">
              <el-input v-model="signForm.passwordNew" show-password></el-input>
            </el-form-item>
            <el-form-item prop="agaginPassword" label="确认新密码:">
              <el-input
                v-model="signForm.agaginPassword"
                show-password
              ></el-input>
            </el-form-item>
            <el-form-item align="left" class="dialog-btns">
              <el-button type="primary" @click="saveUser2">保存</el-button>
            </el-form-item>
          </el-form>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  data() {
    let pattern1 = /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)[^]{6,16}$/;
    var validatePass1 = (rule, value, callback) => {
      if (value === "") {
        callback(new Error("请输入密码"));
      } else {
        if (!pattern1.test(value)) {
          callback(new Error("请输入6-16位且包含数字，大小写字母三种"));
        }
        callback();
      }
    };
    var validatePass2 = (rule, value, callback) => {
      if (value === "") {
        callback(new Error("请输入密码"));
      } else if (value !== this.signForm.passwordNew) {
        callback(new Error("两次输入密码不一致!"));
      } else {
        callback();
      }
    };
    return {
      activeName: "first",
      addForm: {
        userName: "",
        realName: "",
      },
      signForm: {
        passwordOld: "",
        passwordNew: "",
        agaginPassword: "",
      },
      uploadUrl: this.$setting.baseURL + "/api/oss/upload/upload",
      imgUrl: this.$setting.fdsDomain,
      isEmail: false,
      rules: {
        realName: [{ required: true, message: "请输入姓名", trigger: "blur" }],
        gender: [{ required: true, message: "请选择性别", trigger: "change" }],
        avatar: [{ required: true, message: "请选择头像", trigger: "blur" }],
      },
      rulesPass: {
        passwordOld: [
          { required: true, message: "请输入密码", trigger: "blur" },
        ],
        passwordNew: [
          { required: true, message: "请输入密码", trigger: "blur" },
          {
            validator: validatePass1,
            trigger: "blur",
          },
        ],
        agaginPassword: [
          {
            required: true,
            message: "请确认密码",
            trigger: "blur",
          },
          {
            validator: validatePass2,
            trigger: "blur",
          },
        ],
      },
    };
  },
  mounted() {
    this.getCurrentUser();
  },
  methods: {
    handleAvatarSuccess(res, file) {
      let size = file.size / 1024 / 1024 < 1;
      if (
        file.raw.type != "image/jpeg" &&
        file.raw.type != "image/png" &&
        file.raw.type != "image/bmp"
      ) {
        this.$message.error("请选择图片的格式为 jpg、jpeg、png或bmp");
        return false;
      }
      if (!size) {
        this.$message.error("上传图片大小不得超过1MB");
        return false;
      }
      this.addForm.avatar = res.data.path;
    },
    beforeAvatarUpload(file) {},
    saveUser() {
      this.$refs["addForm"].validate((valid) => {
        if (valid) {
          this.$http
            .post("/api/web/user/update", this.addForm)
            .then((data) => {
              this.$message.success(data.message);
              this.getCurrentUser();
            })
            .catch((msg) => {});
        }
      });
    },
    saveUser2() {
      this.$refs["signForm"].validate((valid) => {
        if (valid) {
          this.$http
            .post("/api/web/user/updatePass", this.signForm)
            .then((data) => {
              this.$message.success(data.message);
              this.$store.dispatch("logout");
            })
            .catch((msg) => {
              this.$message.error(msg);
            });
        }
      });
    },
    getCurrentUser() {
      this.$http
        .post("/api/web/user/getUserInfo")
        .then((data) => {
          this.addForm = data.data;
        })
        .catch(({ code, msg }) => {});
    },
    handleClick() {
      console.log(this.activeName);
    },
  },
};
</script>
<style lang="scss" scoped>
.my-msg {
  width: 1040px;
  min-height: 680px;
  margin: 35px auto;
  border: 1px solid rgba(228, 228, 228, 1);
  padding: 15px 30px;
  position: relative;
  background: #ffffff;
  .my-msg-detail {
    width: 400px;
    margin-top: 30px;
  }
}

/deep/.el-upload {
  display: flex;
  align-items: flex-start;
  max-width: 450px;

  .image-con {
    position: relative;
    width: 100px;
    min-width: 100px;
    margin-right: 15px;
    height: 100px;
    text-align: left;
    overflow: hidden;

    &.image-logo {
      width: 100px;
      min-width: 100px;
    }

    img {
      width: 100%;
      height: 100%;
    }

    .imang_hover {
      position: absolute;
      top: 0;
      left: 0;
      display: none;
      background: rgba($color: #000000, $alpha: 0.2);
      height: 100%;
      width: 100%;
      text-align: center;
      color: #fff;

      span {
        line-height: 100px;
        font-weight: 700;
      }
    }

    &.image-user {
      height: 100px;
      border-radius: 50%;

      .imang_hover {
        span {
          line-height: 100px;
        }
      }
    }

    &:hover {
      .imang_hover {
        display: block;
      }
    }
  }

  .image-icon {
    position: relative;
    width: 100px;
    min-width: 100px;
    margin-right: 15px;
    height: 100px;
    border: solid 1px #ddd;
    line-height: 100px;
    color: #ddd;

    &.image-logo {
      width: 100px;
      min-width: 100px;
    }

    .imang_hover {
      position: absolute;
      top: 0;
      left: 0;
      display: none;
      background: rgba($color: #000000, $alpha: 0.2);
      height: 100%;
      width: 100%;
      text-align: center;
      color: #fff;

      span {
        line-height: 100px;
        font-weight: 700;
      }
    }

    &.image-user {
      height: 100px;
      border-radius: 50%;

      .imang_hover {
        span {
          line-height: 100px;
        }
      }
    }

    &:hover {
      .imang_hover {
        display: block;
      }
    }
  }

  .image-detail {
    color: #aaa;
    line-height: 20px;
    text-align: left;
  }
}
.change-email {
  color: rgb(0, 85, 255);
  margin-left: 10px;
  cursor: pointer;
}

.go-mooc {
  color: #3399ff;
  font-size: 14px;
  position: absolute;
  right: 30px;
  z-index: 99;
  top: 20px;
}
</style>